import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { I18nProvider } from "@/i18n/I18nProvider";
import { SmoothScrollProvider } from "@/lib/SmoothScrollProvider";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import GalleryPage from "@/pages/GalleryPage";
import AboutPage from "@/pages/AboutPage";
import NoticePage from "@/pages/NoticePage";
import ContactPage from "@/pages/ContactPage";
import CollectionPage from "@/pages/CollectionPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsConditionsPage from "@/pages/TermsConditionsPage";

function SEOHead() {
  const { pathname } = useLocation();
  useEffect(() => {
    const map = {
      "/": { t: "Ramdev Steel Furniture & Fabrication — Lingsugur, Karnataka", d: "Ramdev Steel manufactures premium steel gates, railings, safety doors, windows, stair railings, swings and custom steel furniture in Lingsugur, Karnataka." },
      "/products": { t: "Products — Ramdev Steel Furniture & Fabrication", d: "Explore our catalogue: steel gates, railings, safety doors, windows, stair railings, swings and custom fabrication." },
      "/gallery": { t: "Gallery — Ramdev Steel Furniture & Fabrication", d: "Completed steel projects across Karnataka." },
      "/about": { t: "About — Ramdev Steel Furniture & Fabrication", d: "A trusted steel furniture manufacturer committed to quality workmanship, durable materials and modern designs." },
      "/notice": { t: "Notice Board — Ramdev Steel Furniture & Fabrication", d: "Offers, holidays and new product launches." },
      "/contact": { t: "Contact — Ramdev Steel Furniture & Fabrication", d: "Call +91 97318 52956, WhatsApp us, or send an enquiry from Lingsugur, Karnataka." },
    };
    let meta = map[pathname];
    if (!meta && pathname.startsWith("/collections/")) {
      const slug = pathname.replace("/collections/", "").replace(/-/g, " ");
      meta = { t: `${slug.replace(/\b\w/g, (c) => c.toUpperCase())} — Ramdev Steel`, d: "Explore this collection from Ramdev Steel Furniture & Fabrication." };
    }
    if (!meta) meta = { t: "Ramdev Steel Furniture & Fabrication", d: "Premium steel furniture and fabrication." };
    document.title = meta.t;
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) { desc = document.createElement("meta"); desc.name = "description"; document.head.appendChild(desc); }
    desc.content = meta.d;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <SmoothScrollProvider>
          <div className="App">
            <SEOHead />
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/collections/:slug" element={<CollectionPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/notice" element={<NoticePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-conditions" element={<TermsConditionsPage />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </main>
            <Footer />
            <FloatingActions />
          </div>
        </SmoothScrollProvider>
      </BrowserRouter>
    </I18nProvider>
  );
}
